var _ellipse, _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProvisionofservices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.3166,
    y: 12.7025,
    width: 2.28734,
    height: 13.2452,
    rx: 0.5,
    transform: "rotate(30 25.3166 12.7025)",
    fill: "white",
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.732 9.20969L14.7856 9.0288C18.1607 3.3438 25.4957 1.41849 31.2379 4.73375C36.9801 8.04901 38.9802 15.364 35.7444 21.1294L35.1146 20.4002C34.3349 19.4976 33.2733 18.8847 32.1018 18.6608C31.1515 18.4792 30.2904 17.982 29.658 17.2499C28.8783 16.3473 27.8167 15.7344 26.6452 15.5104C25.6949 15.3288 24.8338 14.8316 24.2014 14.0995C23.4217 13.1969 22.3601 12.584 21.1886 12.3601C20.2383 12.1784 19.3772 11.6813 18.7448 10.9491C17.9651 10.0465 16.9035 9.43361 15.732 9.20969ZM14.4615 8.96684C14.4616 8.96687 14.4618 8.9669 14.4619 8.96693L14.4615 8.96684Z",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40785 19.5H9.01137V9.79688H5.40785V19.5ZM7.20961 9.26074C8.22914 9.26074 9.00258 8.52246 9.00258 7.55566C9.00258 6.58887 8.22914 5.85059 7.20961 5.85059C6.19008 5.85059 5.41664 6.58887 5.41664 7.55566C5.41664 8.52246 6.19008 9.26074 7.20961 9.26074ZM19.3656 9.79688H15.5951L14.2328 16.5908H14.1625L12.7562 9.79688H8.87144L12.0267 19.5H16.2543L19.3656 9.79688Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9155 18.0008C30.9155 18.0008 32.4206 15.2128 33.0585 13.3099C34 10.5008 34 7.50077 32.2007 5.50077M32.2007 5.50077C29 4.00077 26 6.00078 23.9509 7.57662C22.2148 8.91171 20.2007 11.7463 20.2007 11.7463M32.2007 5.50077C29.5752 8.58835 27.5 11.0008 25.5581 14.8735",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvisionofservices);
export default __webpack_public_path__ + "static/media/provisionofservices.29bd1aa9839b29e6193235d1b36c52a6.svg";
export { ForwardRef as ReactComponent };